import $ from 'jquery';
import { convertStrToMilitaryTime } from '../utilities.js';
import { __ } from '@wordpress/i18n';

$('.js-time-chip').each(function () {
  const now = new Date();
  const currentTime = now.getHours() + now.getMinutes() / 60;
  const openStr = $(this).data('open');
  const closeStr = $(this).data('close');
  const isClosed = $(this).data('is-closed');
  const open = convertStrToMilitaryTime(openStr.split('|')[0], openStr.split('|')[1]);
  const close = convertStrToMilitaryTime(closeStr.split('|')[0], closeStr.split('|')[1]);

  if (isClosed === 1 || currentTime < open || currentTime > close) {
    // If closed for the day OR outside business hours
    $(this).removeClass('active');
    $(this).find('.chip-text').text(__('Closed Now', 'ford-oem-theme'));
  } else {
    // If open
    $(this).addClass('active');
    $(this).find('.chip-text').text(__('Open Now', 'ford-oem-theme'));
  }
});
